<template>
  <div class="shangquantemaiPage">
    <mu-appbar class="search-head">
      <mu-icon-button  icon=":fa fa-angle-left" @click="GoHistory()" style="color:#999;" slot="left"/> 
      <div slot="default" class="search-ctrl">
        <mu-icon value=" " class="fa fa-xisearch" @click="GoSearch()" /> 
        <input class="input-ctrl" @click="GoSearch()" v-model="searchName" placeholder="请输入关键词" />          
      </div>
      <mu-icon-button icon=":fa fa-fenlei1" style="color:#999;" slot="right" />
    </mu-appbar>
    <mu-list  class="paixu">
      <div class="top">
        <mu-flat-button label="分类" :class="categoryShow==true?'active' :' '" @click="categoryClick()" class="demo-flat-button" labelPosition="before" icon=":fa fa-daosanjiao" secondary  slot="left"/>   
        <mu-flat-button label="全城" :class="shangquanShow==true?'active' :' '" @click="shangquanClick()" class="demo-flat-button middle" labelPosition="before" icon=":fa fa-daosanjiao" secondary  slot="left"/>  
        <mu-flat-button label="排序" :class="sortShow==true?'active' :' '" @click="sortClick()" class="demo-flat-button right" labelPosition="before" icon=":fa fa-daosanjiao" secondary  slot="left"/>                    
      </div>  
    </mu-list> 
    <div class="model" @click="initStyle" v-if="publicShow">
    </div> 
    <div class="button-list" v-if="categoryShow">   
      <mu-list class="left">
        <mu-flat-button :label="categoryItem.Fname" class="extension" labelPosition="before" :icon="categoryId==categoryItem.Fid?':fa fa-angle-right' :' '" :class="categoryId==categoryItem.Fid?'active' :' '" @click="getCategoryList(categoryItem.Fid)" 
          v-for="categoryItem in categoryList" :key="categoryItem.Fid" />  
      </mu-list>               
      <mu-list class="right">
        <div class="button-list-item" v-if="subCategoryList.length>0">
          <mu-flat-button class="demo-flat-button" v-for="subCategoryItem in subCategoryList" :key="subCategoryItem.Fid" @click="subCategoryClick(subCategoryItem.Fid)">
            <span :style="{fontSize: '16px',color: '#ff4981'}" v-if="cateId==subCategoryItem.Fid">{{subCategoryItem.Fname}}</span>
            <span :style="{fontSize: '16px',color: '#000'}" v-if="cateId!=subCategoryItem.Fid">{{subCategoryItem.Fname}}</span>
          </mu-flat-button>
          <!-- <mu-flat-button  class="demo-flat-button" ><span style="font-size: 16px;color: #000;">自助餐</span> <span style="font-size: 14px;color: #999;">(20)</span> </mu-flat-button> -->
        </div>
        <div v-if="subCategoryList.length == 0" style="text-align:center; line-height:100px; color:#999;">暂无分类数据</div>
      </mu-list>         
    </div>  
    <div class="button-list" v-if="shangquanShow">   
      <mu-list class="left">
        <mu-flat-button :label="areaItem.area" class="extension" labelPosition="before" :icon="selectCityId==areaItem.areaID?':fa fa-angle-right' :' '" :class="selectCityId==areaItem.areaID?'active' :' '" @click="getShangquanList(areaItem.areaID)" 
          v-for="areaItem in areaList" :key="areaItem.id" />  
      </mu-list>               
      <mu-list class="right">
        <div class="button-list-item">
          <mu-flat-button class="demo-flat-button" v-for="shangquanItem in shangquanList" :key="shangquanItem.Fid" @click="selectShangquan(shangquanItem.Fid)">
          <span :style="{fontSize: '16px',color: '#ff4981'}" v-if="shangquanId==shangquanItem.Fid">{{shangquanItem.Fname}}</span>
          <span :style="{fontSize: '16px',color: '#000'}" v-if="shangquanId!=shangquanItem.Fid">{{shangquanItem.Fname}}</span>
          </mu-flat-button>
          <!-- <mu-flat-button  class="demo-flat-button" ><span style="font-size: 16px;color: #000;">自助餐</span> <span style="font-size: 14px;color: #999;">(20)</span> </mu-flat-button> -->
        </div>
        <div v-if="shangquanList.length == 0" style="text-align:center; line-height:100px; color:#999;">暂无商圈数据</div>
      </mu-list>         
    </div> 
    <div class="button-list" v-if="sortShow">  
      <mu-list>
        <mu-list-item title="综合排序" :class="sort=='normal'?'sort-active' :' '" @click="sortSearch('normal')">
          <mu-icon value=":fa fa-angle-right" slot="right" v-if="sort=='normal'" />
        </mu-list-item>
        <mu-list-item title="人气排序" :class="sort=='saleCount'?'sort-active' :' '" @click="sortSearch('saleCount')">
          <mu-icon value=":fa fa-angle-right" slot="right" v-if="sort=='saleCount'" />
        </mu-list-item>    
        <mu-list-item title="距离排序" :class="sort=='distance'?'sort-active' :' '" @click="sortSearch('distance')">
          <mu-icon value=":fa fa-angle-right" slot="right" v-if="sort=='distance'" />
        </mu-list-item>        
      </mu-list>
    </div>
    
    <mu-list class="proList" style="padding-top: 10px;">

      <mu-list-item v-for="storeItem in storeList" :key="storeItem.Id">
        <div class="product-item" >
          <router-link :to="'/shangquan/pingjia?shopId='+storeItem.ShopId">
            <img :src="storeItem.Image" class="pro-img"> 
            <div class="product-info" :style="{ width:proItemInfoWidth+'px'}">
              <div class="product-name">
                <p class="title">{{storeItem.CompanyName}} </p>
               
              </div> 
              <p class="fiveStar">
                <mu-icon value=":fa fa-star"  slot="left" v-for="sIndex in storeItem.XingJi" :key="sIndex" />
                <mu-icon value=":fa fa-star" class="empty_satr" slot="left" v-for="sIndex in (5-storeItem.XingJi)" :key="sIndex"/>
                <span style="padding-left: 3%; color: rgb(244, 67, 54); font-size: 14px; width:15%;">{{storeItem.XingJi}}分</span>     
                 <span style="color:#666;float:right;">{{storeItem.Distance>1000? (storeItem.Distance/1000).toFixed(1)+'km':storeItem.Distance+'m'}}</span>             
              </p>
              <div class="saleinfo">
                <p class="per_capita">人均<span style="font-size: 12px; color: red;">￥</span><span style="color: red; font-weight: bold; font-size: 17px;">{{storeItem.AverageConsumption}}</span></p>
                  <span class="sale_num">已售{{storeItem.SaleCount}}</span>   
              </div>
              <div class="saleCount">{{storeItem.ShopAddress.length>6?storeItem.ShopAddress.substr(0,6)+"...":storeItem.ShopAddress}}</div>
              <mu-divider shallowInset/>    
              <div class="sale" style="margin-top: 5px;">
                <div class="ipp" v-if="storeItem.IsDiscount == 1">
                  <!-- <img style="height: 70%; display: block; float:left;margin-top:5px;" src=" ../static/shangquan/付.png" alt=""> -->
                  <div class="sale_circle">付</div>
                  <p style="font-size: 14px;">
                    <span style="padding-right: 5px;font-size: 16px;color:#ff4981;">
                      {{storeItem.SaleDiscount}}折 </span>
                    {{storeItem.OpenTime.length>10?storeItem.OpenTime.substr(0,10)+"...":storeItem.OpenTime}}
                  </p>
                </div>      
                <div class="ipp" v-if="storeItem.IsDiscount == 2">
                  <div class="sale_circle">付</div>
                  <p style="font-size: 14px;"><span style="padding-right: 5px;font-size: 16px;color:#ff4981;">BAW抵扣 </span>{{storeItem.OpenTime.length>10?storeItem.OpenTime.substr(0,10)+"...":storeItem.OpenTime}}</p>
                </div>                     
              </div>                
            </div>                
          </router-link>
        </div>
      </mu-list-item>
    </mu-list>
    
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>
import siteconfig from '../../util/siteconfigCache'
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-135),
      searchName: this.$route.query.searchName?this.$route.query.searchName:'',
      publicShow:false,
      categoryShow:false,
      shangquanShow:false,
      sortShow:false,
      categoryId:0,
      storeList:[],
      cityCode:'',
      categoryList:[],
      subCategoryList:[],
      shangquanId:'0',
      countyId:'',
      selectCityId:'',
      areaList:[],
      shangquanList:[],
      sort:'normal',
      lng:window.localStorage.UserLocationLng,
      lat:window.localStorage.UserLocationLat
    }
  },
  mounted() {
     this.cityCode = window.localStorage.ShopsPhysicalProductDetailDeliveryCityCache
     if(!this.cityCode){
       this.cityCode = ''
     }
     this.cateId = this.$route.query.categoryId
     this.getSiteInfo()   
     this.getStorePage()     
     this.getCategoryList(0)
     this.getCountyList()
  },
  methods: {  
    GoHistory(){
      this.$router.goBack()
    },
    GoSearch(){
      this.$router.push('/shangquan/search?searchName='+this.searchName)
    },
    initStyle(){
      this.categoryShow = false
      this.shangquanShow = false
      this.sortShow = false
      this.publicShow = false
    },
    categoryClick(){
      this.categoryShow = !this.categoryShow
      this.shangquanShow = false
      this.sortShow = false
      this.publicShow = this.categoryShow
    },
    shangquanClick(){
      this.categoryShow = false
      this.shangquanShow = !this.shangquanShow
      this.sortShow = false
      this.publicShow = this.shangquanShow
    },
    sortClick(){
      this.categoryShow = false
      this.shangquanShow = false
      this.sortShow = !this.sortShow
      this.publicShow = this.sortShow
    },
    subCategoryClick(subCateId){
      this.categoryShow = false
      this.publicShow = false
      this.cateId = subCateId
      this.getStorePage()
    },
    selectShangquan(shangquanId){
      this.shangquanShow = false
      this.publicShow = false
      this.shangquanId = shangquanId
      this.getStorePage()
    },
    sortSearch(sortFiled){
      this.sort = sortFiled
      this.sortShow = false
      this.publicShow = false
      this.getStorePage()
    },
     getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },      
    getStorePage(){
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalStorePage", {
        'searchName': this.searchName
        ,'areaId':this.cityCode
        , 'categoryId': this.cateId
        , 'shangquanId':this.shangquanId
        , 'pageIndex':1
        , 'pageSize':10
        , 'longitude':this.lng
        , 'latitude':this.lat
        , 'sort': this.sort
      })
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.storeList = res.Data.List

          //ths.$refs.XRtoast.hide();
        }else{
          ths.storeList = []
        }
        
        if(ths.storeList.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{            
          ths.$refs.XRPageTip.initTip()  
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getCategoryList(pid){      
      const ths = this;
      ths.categoryId = pid 
      this.$post("/Shop/StoreServer/GetShopsPhysicalCategoryList", {'pid': pid })
      .then(function(res) {
        if (res.IsSuccess && res.Data) {
          ths.loaded = false;
             
          if(pid>0){
            ths.subCategoryList = res.Data
          }else{        
            ths.categoryList = res.Data
          }

          //ths.$refs.XRtoast.hide();
        }else{
          
          if(pid>0){
            ths.subCategoryList = []
          }else{        
            ths.categoryList = []
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getShangquanList(areaId){      
      this.selectCityId  =areaId
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalShangquanList", {'areaId': areaId })
      .then(function(res) {
        if (res.IsSuccess && res.Data) {
          ths.loaded = false;
            
          ths.shangquanList = res.Data

          //ths.$refs.XRtoast.hide();
        }else{
          ths.shangquanList = []
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getCountyList(){      
      const ths = this;
      this.$post("/Shop/BaseServer/GetAreaListByFatherName", {'fatherName': this.cityCode })
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
            
          ths.areaList = res.Data

          //ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }
  },
  computed: {
    
  }
};
</script>
<style>
body .shangquantemaiPage .search-head{
  height: 56px;
  text-align: center;
  background: rgb(71, 74, 79);
  position: fixed;
  top: 0;
}
.shangquantemaiPage .search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shangquantemaiPage .search-head .left {
    border-radius: 50%;
    background: rgb(153, 153, 153,0.3);
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
}
.shangquantemaiPage .search-head .right {
    border-radius: 50%;
    background: rgb(153, 153, 153,0.3);
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
}
.shangquantemaiPage .search-head .mu-appbar-title {
  font-size: 16px;
  padding: 0 16px;
}
.shangquantemaiPage .search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.shangquantemaiPage .search-head .title .title-text {
  margin: 0;
  line-height: 56px;
}
.shangquantemaiPage .paixu{
  margin-top: 56px;
}
.shangquantemaiPage .mu-list .top{
  text-align: center;
  border-bottom: 1px solid #e1e1e1;
  height: 56px;
  line-height: 56px;
}
.shangquantemaiPage .mu-list .top button{
  width: 32%;
}
.shangquantemaiPage .mu-list .top button .mu-flat-button-wrapper{
  justify-content: right;
}
.shangquantemaiPage .mu-list .top button.middle .mu-flat-button-wrapper{
  justify-content: center;
}
.shangquantemaiPage .mu-list .top .mu-flat-button.right .mu-flat-button-wrapper{
  justify-content: flex-end;
}
.shangquantemaiPage .search-head .search-ctrl{
  width: 100%;
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  color:#ccc;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.shangquantemaiPage .search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  font-size: 12px;
  width: 80%;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  color:#fff;
}
.shangquantemaiPage .search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 28px;
  text-align: right;
  color:#ccc;
}
.shangquantemaiPage .left .mu-flat-button-label{
  color: #000;
  font-size: 16px;
  padding-right: 0;
}
.shangquantemaiPage .search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.shangquantemaiPage .search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
.shangquantemaiPage .mu-appbar-title  .fa-xisearch{
    width: 20%;
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 16px;
    color: #fff;
    background: rgba(255, 255, 255, 0.3);
}
.shangquantemaiPage .search-head .left .mu-icon,.shangquantemaiPage .search-head .right .mu-icon{
  color: #fff
}
.shangquantemaiPage .search-head .mu-flat-button.label-before .fa-angle-down{
  font-size: 14px;
  width: 20px;
  color: #999;
}
.shangquantemaiPage .mu-list{
  background: #fff;
  padding-top: 0;
  padding-bottom: 0;
}
.shangquantemaiPage .model{
  background-color: rgba(0, 0, 0,0.5);
  position: fixed;
  z-index: 20141271;
  height: 100%;
  width: 100%;
}
.shangquantemaiPage .mu-list .mu-item-left{
  border-bottom: 1px solid #f5f5f5;
  padding: 0 5%;
}
.shangquantemaiPage .mu-list .top .mu-flat-button.label-before .mu-flat-button-label{
  padding-right: 0px;
  color: black;
  font-size: 16px;
}
.shangquantemaiPage .mu-list .top .mu-flat-button.label-before.active .mu-flat-button-label{
  color: #ff4981;
}
.shangquantemaiPage .mu-list .mu-flat-button.label-before .fa-daosanjiao{
  font-size: 14px;
  width: 20px;
  color: #999;
  transform: rotate(180deg);
  transition: 250ms;
}
.shangquantemaiPage .mu-list .mu-flat-button.label-before.active .fa-daosanjiao{
  color: red;
  transform: rotate(360deg);
  transition: 250ms;
}
.shangquantemaiPage  .mu-item-left{
  width: 100%;
  left: 0;
}
.shangquantemaiPage .love .mu-item-left{
  left: 16px;
}
.shangquantemaiPage .mu-list .mu-item-left .mu-flat-button{
  flex: 1;
  border-right: 1px solid #f5f5f5;
  padding-right: 0px;
}
.shangquantemaiPage .proList .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px;
}
.shangquantemaiPage .proList .mu-item{
  padding: 0px;
}
.shangquantemaiPage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquantemaiPage .product-item a{  
  color:black;
}
.shangquantemaiPage .product-item .pro-img{
  width: 95px;
  float: left;
  background: white;
  height: 95px;
  object-fit: cover;
}
.shangquantemaiPage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
}
.shangquantemaiPage .product-item  .product-info .product-name{
  overflow:hidden;
  font-size: 14px;

}
.shangquantemaiPage .product-item  .product-info .product-name p.title{
  float: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}
.shangquantemaiPage .product-item .product-info .active{
  overflow: hidden;
}
.shangquantemaiPage .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  color:#999;
  border-radius: 2px;
  margin: 0;
}
.shangquantemaiPage .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
  margin: 5px 0;
}
.shangquantemaiPage .product-item  .product-info .per_capita{
  width: 60%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
  float: left;
}
.shangquantemaiPage .product-item  .product-info .sale_num{
  font-size: 12px;
  color: #666;
  float: right;
}
.shangquantemaiPage .product-item  .product-info .saleinfo .price .fa{
  font-size: 14px;
  margin-right: 5px;
}
.shangquantemaiPage .product-item .product-info .saleCount{
  color:#ccc;
  font-size: 12px;
}
.shangquantemaiPage .product-info .fiveStar{
  align-items: center;
  display: flex;
}
.shangquantemaiPage .proList .fiveStar .fa-star{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: orange;
}
.shangquantemaiPage .proList .fiveStar .empty_satr{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #ccc;
}
.shangquantemaiPage .shop-list .shop-item .shop-product-list{
  overflow: hidden;
}
.shangquantemaiPage .shop-list .shop-item .shop-product-list .shop-product-item{
  width:33.33%;
  float: left;
}
.shangquantemaiPage .shop-list .shop-item .shop-product-list .shop-product-item .pro-img{
  width: 100%;
}

.shangquantemaiPage .shop-list .entrance{
  margin-top: 5%;
  height: 100px;
  padding: 0 3%;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #dedede;
}
.shangquantemaiPage .shop-list .enceimg{
  float: left;
  width: 20%;
  height: 100%;
   display: flex;
  align-items: center;  
  justify-content: center;
}
.shangquantemaiPage .shop-list .enceimg img{
  width: 100%;
}
.shangquantemaiPage .shop-list .store{
  width: 60%;
  height: 100%;
  padding: 3% 1%;
  float: left;
}
.shangquantemaiPage .shop-list .jian{
  width: 20%;
  height: 100%;
  text-align: center;
  padding: 5% 0;
  float: left;
}
.shangquantemaiPage .shop-list .jian img{
  width: 15px;
  height: 10px;

}
.shangquantemaiPage .shop-list .pro-list{
  overflow: hidden;
  width: 100%; 
  padding: 3% 3% 0 3%;
  background: #fff;
}
.shangquantemaiPage .shop-list .pro-list .item-left{
  float: left;
  width: 32%;
  text-align: center;
  background-size: cover;
  position: relative;
}
.shangquantemaiPage .shop-list .pro-list .item-left img{
  width: 90%;
}
.shangquantemaiPage .shop-list .pro-list .item-left span{
  background: #f19500;
  color: white;
  padding:  0 2%;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 3px;
  left: 30px;
}
.shangquantemaiPage .mu-list .proList{
  border-bottom: 1px solid #f5f5f5;
}
.shangquantemaiPage .mu-list .proList:last-child{
  border: 0;
}
.shangquantemaiPage .love ,.proList:last-child{
  border-bottom: 1px solid #f5f5f5;
}
.shangquantemaiPage .love .mu-item.show-left{
  padding-left: 45px;
}
.shangquantemaiPage .mu-list .fa-xingxing{
  font-size: 20px;
}
.shangquantemaiPage .love{
  margin-top: 10px;
}
.shangquantemaiPage .proList1 .demo-flat-button .mu-flat-button-wrapper .mu-flat-button-label{
  font-size: 14px;
  padding: 0px;
  color:#ccc;
}
.shangquantemaiPage .proList1 .demo-flat-button .mu-flat-button-wrapper .fa-angle-right{
  font-size: 16px;
  color: #ccc;
}
.shangquantemaiPage .proList .demo-flat-button .mu-flat-button-wrapper{
  padding-right: 16px;
}
.shangquantemaiPage .proList .mu-divider{
  width: 300px;
  margin: 0;
  margin-top: 5px;
  background-color: #e1e1e1;
}
.shangquantemaiPage .proList .sale .ipp{
    align-items: center;
    font-size: 14px;
    height: 30px;
    display: flex;
}
.shangquantemaiPage .proList .sale .ipp .sale_circle{
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background: #ff4981;
  background: url(' ../../../static/shangquan/te.png');
  background-size: 100% 100%;
  float: left;
  color: #fff;
  text-align: center;
  font-size: 12px;
}
.shangquantemaiPage .proList .sale p{
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    color: #999;
    padding-left: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.shangquantemaiPage .tmbtn .mu-item{
  padding: 0;
}
.shangquantemaiPage  .tmbtn .mu-flat-button-label{
  color:rgb(244, 67, 54);
  font-size: 16px;
  padding: 0px;
}
.shangquantemaiPage  .tmbtn .fa-angle-down,.shangquantemaiPage  .tmbtn .fa-angle-up{
  color: rgb(244, 67, 54);
  font-size: 18px;
}
.shangquantemaiPage .button-list{
  z-index: 20154848;
  position: fixed;
  width: 100%;
  background: #fff;
}
.shangquantemaiPage .button-list .mu-list.left{
  width: 43%;
  float: left;
  height: 400px;
  overflow: auto;
}
.shangquantemaiPage .button-list .mu-list.right{
  width: 50%;
  float: left;
  height: 400px;
  overflow: auto;
}
.shangquantemaiPage .button-list-item{
  z-index: 20154848;
  position: relative;
  background: #fff;
  min-height: 200px;
}
.shangquantemaiPage .button-list-item .demo-flat-button{
  width: 100%;
  margin-bottom: 20px;
}
.shangquantemaiPage .button-list .mu-flat-button-wrapper{
  justify-content: left;
}
.shangquantemaiPage .button-list .mu-flat-button-wrapper .fa-angle-right{
  font-size: 18px;
  color: #ff4981;
}
.shangquantemaiPage .button-list .left .extension  {
  width: 100%;
  margin-bottom: 20px;
}
.shangquantemaiPage .button-list .active .mu-flat-button-label{
  color: #ff4981;
}
.shangquantemaiPage .button-list .sort-active .mu-item-title{
  color: #ff4981;
}
.shangquantemaiPage .button-list .sort-active .mu-item-after{
  color: #ff4981;
}

.shangquantemaiPage .xr-pageTip{
  top:110px;
}

</style>



// WEBPACK FOOTER //
// src/pages/shangquan/temai.vue